
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.548 2.667c0 .4-.255.666-.638.666h-2.105l-3.317 9.334h2.233c.382 0 .637.266.637.666s-.255.667-.637.667H3.98c-.383 0-.638-.267-.638-.667s.255-.666.638-.666h2.105l3.38-9.334H7.17c-.383 0-.638-.266-.638-.666S6.786 2 7.17 2h5.741c.383 0 .638.267.638.667z","fill":"#000"}})])
          )
        }
      }
    